import { useEffect, useState } from 'react';
import axios from 'axios';

const useFetchVouchers = (promoId) => {
    const [numbers, setNumbers] = useState([]);

    useEffect(() => {
        if (!promoId) {
            return;
        }

        axios.get(`${process.env.REACT_APP_API_URL}/client/me/vouchers?promo_id=${promoId}`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
                },
            })
            .then((response) => {
                setNumbers(response.data.data);
            })
            .catch((err) => {
                console.error(err);
            })
    }, [promoId, setNumbers]);

    return numbers;

}

export default useFetchVouchers;